import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {type BUDGET_TYPE} from './constants';

export const fetchBudget = (institutionId: string, year: string, type: BUDGET_TYPE) =>
    RESTClient.getAuthenticatedObservable(`v2/budgets/${institutionId}/${type}/${year}`).map(response =>
        response.reduce(
            (obj, budget) => ({
                ...obj,
                [budget.month]: budget.value,
            }),
            {},
        ),
    );

export const updateBudget = (institutionId: string, values, type: BUDGET_TYPE) =>
    RESTClient.postAuthenticatedObservable(`v2/budgets/${institutionId}/${type}`, {values}).map(response =>
        response.reduce(
            (obj, budget) => ({
                ...obj,
                [budget.month]: budget.value,
            }),
            {},
        ),
    );
